/* SessionContextOverflow.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._0GTcwR1Y8M%7Bmargin-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._1pp6NdIZbP%7Bpointer-events%3Aauto%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._23rrnHyKLB%7Btransition%3Avar(--ds-button-hovered%2Cbackground-color%20border-color%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._4c065UPgdg%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D%0A._2Y7lL4Pgdg%7Bpadding-inline%3Avar(--ds-space-0%2C0)%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._313842dnbC%7Bmargin-top%3A0%7D%0A._0adFHsdnbC%7Bmargin-right%3A0%7D%0A._1DCdHidnbC%7Bmargin-bottom%3A0%7D%0A._2XsHFMdnbC%7Bmargin-left%3A0%7D%0A._1LMyvKYbGa%7Blist-style%3Anone%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._4c065U2ADO%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D%0A._2Y7lL48HPE%7Bpadding-inline%3Avar(--ds-space-150%2C9pt)%7D%0A._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D%0A._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._1EqgXli5ay%7Bmax-width%3Amin(25rem%2C90vw)%7D%0A._0NUa3rAiO0%7Bmax-height%3Amin(25rem%2C80vh)%7D%0A._1ANEUSzUZr%7Bwhite-space%3Anormal%7D");


























import React, { type ReactNode, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Popup } from '@atlaskit/popup/popup';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { messages } from './messages';
const styles = {
  overflow: "_3YEZNOdnbC _0GTcwR1Y8M _1mT5xdRAKS _42Yu6B7dHp _1pp6NdIZbP",
  trigger: "_2sNsIg7NXe _23rrnHyKLB _0bjKvDKxmn _4c065UPgdg _2Y7lL4Pgdg _0KLXru66of _1UtDYzKGUX _1ANEUSLRg7",
  list: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1LMyvKYbGa _0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _4c065U2ADO _2Y7lL48HPE _0KLXrugozt _2OUyjtGk8v _1EqgXli5ay _0NUa3rAiO0 _1ANEUSzUZr _1pp6NdIZbP"
};

/** Click disclosure of all context links, using the shared Popup focus and dismissal behavior. */
export const SessionContextOverflow = ({
  fallbackFocusRef,
  count,
  isOpen,
  onOpenChange,
  children
}: {
  fallbackFocusRef: React.RefObject<HTMLAnchorElement>;
  count: number;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  children: ReactNode;
}): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const hasPopupFocus = useRef(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    const fallback = fallbackFocusRef.current;
    return () => {
      onOpenChange(false);
      if (hasPopupFocus.current && fallback?.isConnected) {
        fallback.focus();
      }
    };
  }, [fallbackFocusRef, onOpenChange]);
  return <Box as="span" xcss={styles.overflow} onKeyDownCapture={event => {
    if (event.key === 'Escape' && isOpen) {
      event.preventDefault();
      event.stopPropagation();
      triggerRef.current?.focus();
      onOpenChange(false);
    }
  }}>
			<Popup isOpen={isOpen} onClose={() => onOpenChange(false)} role="dialog" label={formatMessage(messages.contextsLabel)} placement="bottom-start" shouldFitViewport shouldRenderToParent content={() => <Box as="ul" xcss={styles.list} aria-label={formatMessage(messages.contextsLabel)} onFocusCapture={() => {
      hasPopupFocus.current = true;
    }} onBlurCapture={event => {
      if (event.relatedTarget && !event.currentTarget.contains((event.relatedTarget as Node))) {
        hasPopupFocus.current = false;
      }
    }}>
						{children}
					</Box>} trigger={triggerProps => <Pressable {...triggerProps} ref={element => {
      triggerRef.current = element;
      if (typeof triggerProps.ref === 'function') {
        triggerProps.ref(element);
      } else if (triggerProps.ref) {
        (triggerProps.ref as React.MutableRefObject<HTMLElement | null>).current = element;
      }
    }} xcss={styles.trigger} aria-label={formatMessage(messages.additionalContextsLabel, {
      count
    })} onClick={() => onOpenChange(!isOpen)}>
						{formatMessage(messages.additionalContexts, {
        count
      })}
					</Pressable>} />
		</Box>;
};